import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter } from "@chakra-ui/react"

const ModalDelete = ({ isOpen, onClose, title, handleConfirmDelete }: any) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent borderRadius={15} padding={5}>
                <ModalHeader textAlign='center'>{title}</ModalHeader>
                <ModalCloseButton onClick={onClose} _focus={{ outline: 'none', boxShadow: 'none' }} />
                <ModalBody textAlign='center' marginTop={-5}>
                    Are you sure you want to delete it?
                </ModalBody>
                <ModalFooter style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 10 }}>
                    <Button onClick={onClose} borderColor='#D0D5DD' bgColor='white'>Cancel</Button>
                    <Button onClick={handleConfirmDelete} bgColor='#D92D20' color='white'>Delete</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalDelete;